export const checkOfficeTag = (tag:any): string | null => {
    return (!IsReeltimeTag(tag) ? tag : null);
}

export const IsReeltimeTag = (tag:any): boolean => {
    return (tag && tag?.trim()?.toLocaleLowerCase() == 'reeltime' ? true : false);
}